import {
  trackEvent,
  validateViewForEmailCapture,
  setEmailCaptureModalCookie,
  setPhoneCaptureModalCookie
} from '@components/EmailCapture/utils';

import { EMAIL_CAPTURE_MODAL_DELAY } from '@components/EmailCapture/constants';
import { PHONE_CAPTURE_RULES } from "@components/EmailCapture/constants";

export const state = {
  emailModalShown: false,
  phoneModalShown: false,
  successModalShown: false,
  experiments: undefined,
  subscribed: false,
  subscribedToSms: false,
};

export const getters = {};

export const actions = {
  trackEvent({ state }, eventName) {
    const { experiments } = state;
    trackEvent(eventName, experiments);
  },

  closeEmailModal({ commit, dispatch }) {
    setEmailCaptureModalCookie();
    dispatch('trackEvent', 'emailCaptureModalClose');
    //- New Segment event (bellow) for email capture modal view, we should remove the old (above) one once we have enough data
    dispatch('trackEvent', 'Email Capture - Email Modal Close');
    commit('setEmailModalShown', false);
  },

  closePhoneModal({ commit, dispatch }) {
    setPhoneCaptureModalCookie();
    dispatch('trackEvent', 'Email Capture - Phone Modal Close');
    commit('setPhoneModalShown', false);
  },

  openEmailModal({ commit, dispatch }) {
    dispatch('trackEvent', 'emailCaptureModalView');
    //- New Segment event (bellow) for email capture modal view, we should remove the old (above) one once we have enough data
    dispatch('trackEvent', 'Email Capture - Email Modal View');
    commit('setEmailModalShown', true);
  },

  openPhoneModal({ commit, dispatch }) {
    dispatch('trackEvent', 'Email Capture - Phone Modal View');
    commit('setPhoneModalShown', true);
  },

  openSuccessModal({ commit, dispatch }) {
    dispatch('trackEvent', 'Email Capture - Success Modal View');
    commit('setSuccessModalShown', true);
  },

  runEmailCapture({ dispatch }) {
    const showEmailCapture = validateViewForEmailCapture(window.cdata);

    if (!showEmailCapture) {
      return;
    }

    let delay = EMAIL_CAPTURE_MODAL_DELAY.delay;

    modalTimeout = setTimeout(() => {
      dispatch('openEmailModal');
      clearTimeout(modalTimeout);
    }, delay);
  },

  runPhoneCapture({ dispatch }, params = {}) {
    const { cdata } = params;
    const rulePayload = {
      rules: PHONE_CAPTURE_RULES,
    };

    const showPhoneCapture = validateViewForEmailCapture(cdata, rulePayload);
    if (!showPhoneCapture) {
      return;
    }

    dispatch('openPhoneModal');
  }
};

let modalTimeout;
export const mutations = {
  setSubscribed(state, val) {
    // Just in case the customer uses the footer form before the modal is displayed
    clearTimeout(modalTimeout);
    state.subscribed = !!val;
  },

  setSubscribedToSms(state, val) {
    clearTimeout(modalTimeout);
    state.subscribedToSms = !!val;
  },

  setEmailModalShown(state, val) {
    state.emailModalShown = !!val;
  },

  setPhoneModalShown(state, val) {
    state.phoneModalShown = !!val;
  },

  setSuccessModalShown(state, val) {
    state.successModalShown = !!val;
  },

  setExperiments(state, experiments) {
    state.experiments = experiments;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
